// extracted by mini-css-extract-plugin
export default {"main":"styles_main__FGDVz","active":"styles_active__CemFy"};